<template>
    <v-row>
        <v-col cols="12" sm="6" md="4">
            <v-list>
                <show-field :value="item.apellido" label="Apellido" icon="person" />
                <show-field :value="item.nombre" label="Nombre" icon="person" />
                <show-field :value="item.email" label="Email" icon="email" />
            </v-list>
        </v-col>
        <v-col cols="12" sm="6" md="4">
            <v-list>
                <show-field :value="item.telefono" label="Teléfono" icon="phone" />
                <show-field :value="item.comision != null ? item.comision + '%' : '-'" label="Comisión" icon="percent" />
                <show-field :value="item.deposito && item.deposito.nombre" label="Depósito" icon="warehouse" />
                <show-field :value="item.activo ? 'Activo' : 'Inactivo'" label="Estado" icon="toggle_on" />
            </v-list>
        </v-col>
    </v-row>
</template>

<script>
import { ShowField } from "@dracul/common-frontend";

export default {
    name: "VendedorShowData",
    components: { ShowField },
    props: {
        item: { type: Object, required: true },
    },
};
</script>
